import { AURORA_RUBY_WIDGET_NAME_MAPPING, AURORA_WIDGETS_LIST } from "../constants/layout";
import { Slot } from "@/data/types/Slot";

// check and return true if response contains layout created in commerce composer
export const filterAuroraLayouts = (layout:any) => {
	let widgetNames : string[] = layout?.slots?layout.slots.map((slot: { widgets: any[]; }) =>{
		return slot.widgets.map(widget =>{
			return widget.widgetName
		})
	}).flat():[];
	widgetNames = widgetNames.filter((widgetName, i) => {return i===widgetNames.findIndex((name)=> name===widgetName)});
    let isAuroraLayout = false;
	widgetNames.forEach((widgetName)=>{
		if(AURORA_WIDGETS_LIST.includes(widgetName))isAuroraLayout = true;
	});
	return isAuroraLayout ? undefined : layout;
}

export const replcaeAuroraWidgetsInSlots = (slots:Slot[] | undefined) : any => {
				slots?.forEach((slot)=>{
					slot.widgets.forEach((widget)=>{
						widget.widgetName = AURORA_RUBY_WIDGET_NAME_MAPPING[widget.widgetName]?
												AURORA_RUBY_WIDGET_NAME_MAPPING[widget.widgetName]
												:
												widget.widgetName;
					})
				});
	return slots;
}